import { Component, Input } from '@angular/core';

export interface NavItem {
  label: string;
  routerLink: string | string[];
  icon?: string;
  exactMatch?: boolean;
  active?: boolean;
}

export interface MainNavConfig {
  items: NavItem[];
  adminOffset?: boolean;
}

@Component({
  selector: 'app-main-navigation',
  templateUrl: './main-navigation.component.html',
  styleUrls: ['./main-navigation.component.scss']
})
export class MainNavigationComponent {
  @Input() config: MainNavConfig = { items: [] };
}
